// extracted by mini-css-extract-plugin
export var labelWrapper = "_gl-0";